import { SiteIdOverrideConfig } from "stores/wizard/config";

// tslint:disable-next-line: variable-name
export const siteId6_en_GB: SiteIdOverrideConfig = {
  package: {
    navigation: {
      tabTitleToken: "wizard.package.tab.title.variant.1.label",
    },
  },
};
